import React from 'react';
import { getComponent } from '../helper';
import './Section.scss';

const Section = ({ sectionBuilder, width }) => <div className={`Section Section--${width}`}><div>{sectionBuilder.map(section => getComponent(section))}</div></div>;

export default Section;